import React from 'react';
import { ListGroup, ListGroupItem, Badge, Col, Row } from 'react-bootstrap';
import { Chart } from 'react-google-charts';
import getCurLang from '../../../businessLogic/getCurLang.js';
import _ from 'lodash';

import { gettext } from '../../../i18n/service.js';

export default class StatisticsInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      options: {
        seriesType: 'bars', 
        series: { 5: { type: 'line' } },
        legend: { position: 'none' },
        colors: ['#80439a', '#f47b47', 'blue'],
        backgroundColor: '#f3f3f3'
      }
    };
  }

  renderDriverInfo() {
    const { statistic, id, title } = this.props;
    let data = [], item = [];
    if(id == 'completedOrders') {
      data = [['title', gettext('COMPLETED-ORDERS-COMMENTONE') + (getCurLang() === 'ar' ?":  ":""), gettext('COMPLETED-ORDERS-COMMENTONE') + (getCurLang() === 'ar' ?":  ":"")]]
    } else if( id == 'cashonDelivery') {
      data = [['title', gettext('CASH-OND-DELIVERY-COMMENTONE') + (getCurLang() === 'ar' ?":  ":""), gettext('CASH-OND-DELIVERY-COMMENTONE') + (getCurLang() === 'ar' ?":  ":"")]]
    } else if(id == 'acceptanceRate') {
      data = [['title', gettext('ACCEPTANCE-RATE-COMMENTONE') + (getCurLang() === 'ar' ?":  ":""), gettext('ACCEPTANCE-RATE-COMMENTONE') + (getCurLang() === 'ar' ?":  ":"")]]
    } else if(id == 'pickupPunctuality') {
      data = [['title', gettext('PICKUP-PUNCTUALITY-COMMENTONE') + (getCurLang() === 'ar' ?":  ":""), gettext('PICKUP-PUNCTUALITY-COMMENTONE') + (getCurLang() === 'ar' ?":  ":"")]]
    } else if(id == 'deliveryPunctuality') {
      data = [['title', gettext('DELIVERY-PUNCTUALITY-COMMENTONE') + (getCurLang() === 'ar' ?":  ":""), gettext('DELIVERY-PUNCTUALITY-COMMENTONE') + (getCurLang() === 'ar' ?":  ":"")]]
    }

    if (!statistic.length > 0)
      return null;

    statistic.map(item => {
      if (item.title != 'total') {
        if(id == 'completedOrders') {
          item = [
            item.title,
            item.deliveredReturnedRatios.totalDelivered,
            item.deliveredReturnedRatios.totalReturned
          ];
        } else if( id == 'cashonDelivery') {
          item = [
            item.title,
            item.cashOnDelivery.cashReturnedToHub,
            item.cashOnDelivery.cashInHand
          ];
        } else if(id == 'acceptanceRate') {
          item = [
            item.title,
            item.orderAcceptance.acceptedOrdersAmount,
            item.orderAcceptance.declinedOrdersAmount
          ];
        } else if(id == 'pickupPunctuality') {
          item = [
            item.title,
            item.pickUpTimeAccuracy.pickedUpInTime,
            item.pickUpTimeAccuracy.notPickedUpInTime
          ];
        } else if(id == 'deliveryPunctuality') {
          item = [
            item.title,
            item.deliveryTimeRatios.deliveredInTime,
            item.deliveryTimeRatios.notDeliveredInTime
          ];
        }
        data.push(item)
      }
      
    });

    return (
      <Col sm={12} className="bar-chart-container">
        <div className="title">{this.props.title}</div>
        <Chart
          chartType="ComboChart"
          data={data}
          options={this.state.options}
          graph_id={id}
          width="100%"
          height="500px"
        />
      </Col>
    );
  }

  render() {
    return (
      <Row>
        {this.renderDriverInfo()}
      </Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/components/StatisticsInfo.js